(function () {
  if (typeof acf === "undefined" || typeof acf.addAction !== "function") {
    return;
  }

  acf.addAction("render_block_preview/type=newsletter-cta", function ($block) {
    if (typeof window.rocketBindNewsletterForms !== "function") {
      return;
    }

    const el = $block && $block[0] ? $block[0] : null;
    window.rocketBindNewsletterForms(el || document);
  });
})();
